var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"M.906 0C.39.046-.002.48 0 1v41.998c0 .552.448 1 1 1h32c.55 0 1-.448 1-1V25.404L38.7 20.7c.19-.186.297-.442.297-.71 0-.266-.108-.522-.298-.71l-4.5-4.5c-.06-.06-.13-.113-.203-.156V8c0-.27-.106-.53-.298-.72l-7-7C26.514.098 26.262-.003 26 0H1C.97-.004.937-.004.906 0zM2 2h23v6c0 .522.476 1 1 1h6v6.577L18.796 28.78c-.13.13-.222.29-.266.468l-1.5 6c-.088.343.01.708.26.958.252.25.617.35.96.26l6-1.5c.17-.046.328-.138.452-.265L32 27.405v14.594H2v-40zm25 1.405L30.592 7H27V3.404zm6.5 13.5l3.093 3.093L24 32.576l-3.095-3.078L33.5 16.904zM20.045 31.45l2 2-2.67.673.67-2.672z"}));
}

Edit.defaultProps = {"width":"39","height":"44","viewBox":"0 0 39 44"};

module.exports = Edit;

Edit.default = Edit;
